import { Button } from '@mui/material';
import styled from 'styled-components';

export const Title = styled.div`
  height: 56px;
  display: flex;
  padding: 0 17px;
  justify-content: space-between;
`;

export const TextFieldContainer = styled.div`
  padding: 16px 27px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 112px;
  border-top: 1px solid #d8dbe0;
`;

export const SwitchContainer = styled.div`
  padding: 16px 27px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #d8dbe0;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  padding: 24px;
`;

export const ApplyFilterButton = styled(Button)`
  background: #1565c0;
  color: white;
  margin-left: 12px;

  &:disabled {
    background: #1565c0;
    mix-blend-mode: normal;
    opacity: 0.5;
    color: #ffffff;
  }
`;
